module.exports = __webpack_public_path__ + "7a60a64254613eceff6ac08e4d6cc826.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter_person_2x.png
// module id = 34
// module chunks = 0 1 2 3 4